import React, { Component } from 'react';

import {
    Button, Card, DataTable, DialogContainer, Grid, CardText,
    TableBody, TableColumn, Autocomplete, TableRow, TableHeader, DatePicker,
} from 'react-md';

import Api from '../../common/api';
import { formatCurrency } from '../../common/formaters';
import { TextField as Text } from '@material-ui/core/TextField';
import Message from '../../components/message';
import Breadcrumb from '../../components/Breadcrumb';
import { openSnackbar } from '../../components/message';

import { Pedido } from '../../models/Pedido';
import Filter from '../../components/Filter';
import PedidoForm from '../../forms/PedidoForm';
import { TextField } from 'material-ui';

const TODAY = new Date();

export default class PedidosHome extends Component {

    constructor(props) {
        super(props);

        this.state = {
            filterType: Autocomplete.caseInsensitiveFilter,
            comprador: {
                id: "",
                nome: "",
                saldo_devedor: "",
            },
            nome_comprador: "",
            id_comprador: "",
            compradores: [],
            pedidos: [],
            latestPedido: [],
            saldo_devedor: "",
            saldo_anterior: "",
            response_api: "",
            visibleConfirm: false,
            visibleForm: false,
            pageX: null,
            pageY: null,
            selectedItem: new Pedido(),
            filter: "",
            visible: false,
            printVisible: false,
            buttonDisable: true,
            pedidosTotal: "",
            counter: 0,
            data_inicial: "",
            data_final: "",
        };


    }

    componentDidMount() {
        this.getAll();
        this.getCompradores();
        this.getAllPedidos();
        this.getPedidosTotal();
        this.setFilterInitialDate();
    }

    render() {
        const { selectedItem, counter, printVisible, compradores, saldo_devedor, saldo_anterior, comprador, visibleForm, pageX, pageY, visibleConfirm, nome_comprador, pedidosLastId } = this.state;
        const confirmActions = [];

        confirmActions.push({ secondary: true, children: 'Cancelar', onClick: this.hideConfirm });
        confirmActions.push(<Button flat primary onClick={this.deletePedido}>Sim</Button>);

        this.actions = [{
            label: 'Continuar',
            primary: true,
            onClick: this.handlePedido,
            disabled: this.state.buttonDisable,
        }, {
            label: 'Fechar',
            secondary: true,
            onClick: this.hide,
        }];

        return (
            <Grid  >
                <Breadcrumb title="Pedidos" url="/pedidos/lista" />
                <Card tableCard className="md-cell md-cell--12 tw-card">
                    <div className="buttons__group">
                        <div className="left-group">
                            <Button type="button" raised primary iconChildren="add" onClick={this.handleNewClick}
                                aria-controls="modal-form">
                                Novo
                            </Button>
                        </div>
                        <div className="right-group">
                            <Button type="button" raised iconChildren="edit" onClick={this.editPedido}
                                disabled={this.hasSelected()} className="btn btn-secondary" aria-controls="modal-form">
                                Editar
                            </Button>
                            <Button type="button" raised primary iconChildren="delete" onClick={this.handleDeleteCLick}
                                disabled={this.hasSelected()} className="btn btn-danger" >
                                Excluir
                            </Button>
                        </div>
                    </div>

                    <Filter onSearch={this.getAllPedidos} placeholder="Pesquise por código ou descrição" />

                    <div style={{display:"flex"}}>
                        <DatePicker id="data_inicial" label="Selecione a data inicial"
                            autoOk className="md-cell md-cell--bottom" defaultValue={new Date(TODAY.getFullYear(), TODAY.getMonth(), 1)} 
                            onChange={this.handleChangeData('data_inicial')} />
                        
                        <DatePicker id="data_final" label="Selecione a data final"
                            autoOk className="md-cell md-cell--bottom" defaultValue={TODAY} 
                            onChange={this.handleChangeData('data_final')} />

                        <Button onClick={this.getAllPedidos} raised primary >Consultar</Button>
                    </div>

                    <div className="md-text--secondary" style={{margin:"0 0 1% 82%", }}>Total de Pedidos: {this.state.pedidosTotal}</div>

                    <DataTable baseId="itens-list" className="tw-table" plain={true} responsive>
                        <TableHeader>
                            <TableRow>
                                <TableColumn>Pedido</TableColumn>
                                <TableColumn>Cliente</TableColumn>
                                <TableColumn>Data</TableColumn>
                                <TableColumn>Observação</TableColumn>
                                <TableColumn className="column--currency">Total</TableColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {this.state.pedidos.map((item, index) => (
                                <TableRow key={index} onClick={this.handleItemClick(item)} aria-controls="modal-form"
                                    className={this.renderSelectedClass(item)}>
                                    <TableColumn>{item.id}</TableColumn>
                                    <TableColumn>{item.nome}</TableColumn>
                                    <TableColumn>{item.criado}</TableColumn>
                                    <TableColumn>{item.observacao}</TableColumn>
                                    <TableColumn className="column--currency">{formatCurrency(item.total)}</TableColumn>
                                </TableRow>
                            ))}
                        </TableBody>
                    </DataTable>
                </Card>

                <DialogContainer id="confirm-dialog" visible={visibleConfirm}
                    onHide={this.hideConfirm} actions={confirmActions} title="Atenção" >
                    <p>Deseja realmente excluir esse registro?</p>
                </DialogContainer>

                <DialogContainer id="pedido-dialog" aria-describedby="pedido-dialog-content"
                    title="Cliente" visible={this.state.visible} onHide={this.hide}
                    actions={this.actions} height={'auto'} width={'70%'} >

                    <Autocomplete id="nome" label="Cliente" data={compradores} filter={null} onChange={this.onSearchAutocomplete}
                        clearOnAutocomplete simplifiedMenu={false} onAutocomplete={this.handleAutocomplete} dataLabel={"nome"}
                        sameWidth={false} value={nome_comprador} className="md-cell md-cell--bottom" dataValue="id" />

                </DialogContainer>

                <PedidoForm
                    model={selectedItem}
                    pageX={pageX}
                    pageY={pageY}
                    counter={counter}
                    nome_comprador={nome_comprador}
                    comprador={comprador}
                    saldo_devedor={saldo_devedor}
                    saldo_anterior={saldo_anterior}
                    pedidos_id={"Novo Pedido"}
                    onSave={this.saveForm}
                    visible={visibleForm}
                    printVisible={printVisible}
                    onHide={this.hideForm}
                    onChange={this.handleChangeItem} 
                />

                <Message />
            </Grid>
        );
    }

    handleChangeData = name => value => {
        this.setState({ [name]: value });
    }

    getAllPedidos = filter => {

        if (typeof filter == "string") {
            this.setState({ filter });
        } else {
            if (!this.state.filter) {
                this.setState({filter: null})
            }
        }
        setTimeout(() => {
            Api.getAllPedidos(this.state.filter, this.state.data_inicial, this.state.data_final)
                .then(response => response.json())
                .then(pedidos => this.setState({ pedidos: pedidos.pedidos, latestPedido: pedidos.pedidos }))
                .catch(error => openSnackbar({ message: error }));
        })
    }

    getPedidosTotal = () => {
        setTimeout(() => {
            Api.getPedidosTotal()
                .then(response => response.json())
                .then(pedidosTotal => this.setState({ pedidosTotal }))
                .catch(error => openSnackbar({ message: error }));

        })
    }

    getCompradores = filter => {
        Api.getAllCompradores()
            .then(response => response.json())
            .then(compradores => this.setState({ compradores }))
            .catch(error => openSnackbar({ message: error }));
    }

    onSearchAutocomplete = value => {

        this.setState({ nome_comprador: value });
        if (value.length === 0) {
            let comprador = {
                id: "",
                nome: "",
                saldo_devedor: "",
                telefones: [],
            }
            this.setState({ comprador });
        }
        if (value.length < 3) return;
        Api.getAllCompradores(value)
            .then(response => response.json())
            .then(compradores => this.setState({ compradores }))
            .catch(error => openSnackbar({ message: error }));
    }

    handleAutocomplete = (value, index, matches) => {
        this.setState({ buttonDisable: false })

        let comprador = matches[index];
        this.setState({ nome_comprador: comprador.nome });
        this.setState({ id_comprador: comprador.id });

        setTimeout(() => {
            this.setState({ comprador })
        });
    };

    getAll = () => {
        Api.getAllItens()
            .then(response => response.json())
            .then(itens => this.setState({
                itens: itens.map(item => {
                    item.custo_unitario = formatCurrency(item.custo_unitario);
                    return item;
                })
            }))
            .catch(error => openSnackbar({ message: error }));
    }

    getCompradores = filter => {
        Api.getAllCompradores()
            .then(response => response.json())
            .then(compradores => this.setState({ compradores }))
            .catch(error => openSnackbar({ message: error }));
    }

    handleChangeItem = value => {
        this.setState({ selectedItem: value });
    }

    handleItemClick = selectedItem => event => {
        
        this.setState({ selectedItem });
        setTimeout(() => this.setState({ selectedItem }), 100);
    }

    handlePedido = event => {
        this.cleanSelectedUsuario();
        this.showForm(event);
        this.hide();
    }

    editPedido = event => {
        this.setState({printVisible: false})
        setTimeout(() => {
            Api.getPedido(this.state.selectedItem)
            .then(response => response.json())
            .then(retorno => this.setState({comprador: retorno.comprador}))
            .catch(error => openSnackbar({ message: error }));
        });

        this.setState({counter: this.state.selectedItem.itens.length})

        this.showForm(event);
    }


    hide = () => {
        this.setState({ visible: false });
    }

    show = () => {
        this.setState({ visible: true });
    };

    handleNewClick = () => {
        setTimeout(() => {
        this.cleanSelectedItem();
        });
        this.setState({printVisible: false})
        this.show()
    }

    handleEditCLick = event => {
        this.showForm(event);
    }

    handleDeleteCLick = () => {
        this.showConfirm();
    }

    cleanSelectedUsuario = () => {
        const selectedItem = new Pedido();
        this.setState({selectedItem});
    }

    deletePedido = () => {
        setTimeout(() => {
            Api.deletePedido(this.state.selectedItem)
                .then(() => { this.afterDeleteItem() })
                .catch(error => openSnackbar({ message: error }));
            this.hideConfirm();
        })
    }

    hideForm = () => {
        this.setState({ visibleForm: false });
        this.cleanSelectedItem();
        this.getAllPedidos(this.state.filter)
    }

    showForm = (e) => {
        let { pageX, pageY } = e;
        if (e.changedTouches) {
            pageX = e.changedTouches[0].pageX;
            pageY = e.changedTouches[0].pageY;
        }
        this.setState({ visibleForm: true, pageX, pageY });
    }

    showConfirm = () => {
        this.setState({ visibleConfirm: true });
    };

    hideConfirm = () => {
        this.setState({ visibleConfirm: false });
    };

    saveForm = item => {
        let selectedItem = new Pedido(item);
        selectedItem.beforeSave();
        setTimeout(() => {
            Api.savePedido(selectedItem)
            .then(response => this.afterSaveForm(response.status, response.json()))
        });
    }

    afterSaveForm = async(status,retorno) => {
        if (status === 403) {
            openSnackbar({ message: 'Nome já utilizado ou iniciado com números' })
        } else {
            let response = await retorno;
            this.setState({saldo_anterior: response.saldo_anterior, saldo_devedor: response.saldo_devedor})
            this.setState({printVisible: true});
            openSnackbar({ message: 'Pedido salvo com sucesso' });
            this.getAllPedidos(this.state.filter)
            this.getPedidosTotal();
        }
    }

    afterDeleteItem = () => {
        this.cleanSelectedItem();
        this.getAllPedidos(this.state.filter)
        this.getPedidosTotal();
        openSnackbar({ message: 'Pedido Excluído com sucesso' });
    }

    cleanSelectedItem = () => {
        const selectedItem = new Pedido();
        this.setState({ selectedItem });
    }

    renderSelectedClass = (item) => {
        return item.id === this.state.selectedItem.id ? "item-selected" : "";
    };

    hasSelected = () => this.state.selectedItem.id ? false : true;

    setFilterInitialDate = () => {
        let data_inicial = new Date(TODAY.getFullYear(), TODAY.getMonth(), 1);
        let data_final = TODAY;
        this.setState({
            data_inicial: data_inicial.toLocaleDateString(), 
            data_final: data_final.toLocaleDateString()
        });
    }

}



// WEBPACK FOOTER //
// ./src/views/pedidos/PedidosHome.js